export default {"src":"/_next/static/media/menu.41b1f281.svg","height":15,"width":20,"blurWidth":0,"blurHeight":0};